import React from 'react'
import { useNavigate } from 'react-router-dom';
import './Cards.css'

function Cards() {

    const cardData = [
        { id: 'west-side', imgSrc: 'https://assets.tatacliq.com/medias/sys_master/images/63600370974750.png' },
        { id: 'womens-wear', imgSrc: 'https://assets.tatacliq.com/medias/sys_master/images/63600371040286.png' },
        { id: 'mens-wear', imgSrc: 'https://assets.tatacliq.com/medias/sys_master/images/63600371105822.png' },
        { id: 'bags', imgSrc: 'https://assets.tatacliq.com/medias/sys_master/images/63600371171358.png' },
        { id: 'watches', imgSrc: 'https://assets.tatacliq.com/medias/sys_master/images/63600371236894.png' },
        { id: 'footwear', imgSrc: 'https://assets.tatacliq.com/medias/sys_master/images/63600371302430.png' },
        { id: 'kids', imgSrc: 'https://assets.tatacliq.com/medias/sys_master/images/63600371367966.png' },
        { id: 'jewellery', imgSrc: 'https://assets.tatacliq.com/medias/sys_master/images/63600371433502.png' },
        { id: 'beauty', imgSrc: 'https://assets.tatacliq.com/medias/sys_master/images/63600371499038.png' },
        { id: 'homes-living', imgSrc: 'https://assets.tatacliq.com/medias/sys_master/images/63600371564574.png' },
        { id: 'gadget', imgSrc: 'https://assets.tatacliq.com/medias/sys_master/images/63600371630110.png' }
      ];

      const navigate = useNavigate();
      const handleCardClick = (id) => {
        navigate(`/category/${id}`);
      }


  return (
    <div className="cards-container">
        <div className="cards-row">
            {cardData.map((card) => (
                <div className="card"
                key={card.id}
                onClick={() => handleCardClick(card.id)}
                >
                <img src={card.imgSrc} alt="" className='card-img' />
                </div>
            ))}
        </div>
    </div>
  )
}

export default Cards